var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "publication" }, [
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        { staticClass: "wrap-padding" },
        [
          !_vm.breakpointDownMd
            ? _c("section", { staticClass: "filters" }, [
                _c(
                  "ul",
                  { staticClass: "filtre-taaf-rnn" },
                  _vm._l(_vm.filters, function (item, indexFilter) {
                    return _c("li", { key: indexFilter }, [
                      _c("a", {
                        class: { active: _vm.form.taxoId === item.id },
                        attrs: { href: "" },
                        domProps: { innerHTML: _vm._s(item.label) },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.filtreSite(item.id)
                          },
                        },
                      }),
                    ])
                  }),
                  0
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.breakpointDownMd
            ? _c("custom-select", {
                staticClass: "mobile-custom-select",
                attrs: {
                  "value-field": "id",
                  "label-field": "label",
                  options: _vm.filters,
                },
                on: {
                  change: function ($event) {
                    return _vm.filtreSite(null, true)
                  },
                },
                model: {
                  value: _vm.form.taxoId,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "taxoId", $$v)
                  },
                  expression: "form.taxoId",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.loading
            ? _c("div", { staticClass: "loader-wrap" }, [_vm._m(0)])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { attrs: { id: "goto-result" } }),
          _vm._v(" "),
          _vm._l(_vm.result, function (item, indexTaxo) {
            return _c(
              "div",
              { key: indexTaxo, staticClass: "list-taxo" },
              [
                _c(
                  "h2",
                  {
                    staticClass: "titre-rubrique",
                    class: { active: item.selected },
                    on: {
                      click: function ($event) {
                        return _vm.toggleWrap(item, $event)
                      },
                    },
                  },
                  [_vm._v(_vm._s(item.taxoName))]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "list-wrap",
                    style: { display: item.selected ? "block" : "none" },
                  },
                  _vm._l(item.childPost, function (item, indexChildPost) {
                    return _c(
                      "article",
                      {
                        key: "key_" + indexChildPost,
                        staticClass: "item publication",
                        class: { focus: _vm.form.page === 1 },
                        attrs: { "data-index": indexChildPost },
                      },
                      [
                        _c("div", { staticClass: "wrap-mobile" }, [
                          _c("div", { staticClass: "bloc-titre" }, [
                            _c("h3", {
                              staticClass: "titre",
                              domProps: { innerHTML: _vm._s(item.title) },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "infos-file" }, [
                            _c("p", [_vm._v(_vm._s(item.infosFile))]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "echeance" }, [
                            _c("p", {
                              domProps: { innerHTML: _vm._s(item.echeance) },
                            }),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "cta" }, [
                          _c(
                            "a",
                            {
                              staticClass: "simple",
                              attrs: { href: item.url, download: "" },
                            },
                            [_c("span", { staticClass: "icon-download" })]
                          ),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _vm._l(item.subChildPost, function (subItems, indexChild) {
                  return subItems.childPost && subItems.childPost.length !== 0
                    ? _c(
                        "div",
                        { key: _vm.indexChildPost, staticClass: "list-taxo" },
                        [
                          _c(
                            "h3",
                            {
                              staticClass: "titre-rubrique",
                              class: { active: subItems.selected },
                              on: {
                                click: function ($event) {
                                  return _vm.toggleWrap(subItems, $event)
                                },
                              },
                            },
                            [_vm._v(_vm._s(subItems.taxoName))]
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "editor",
                            domProps: { innerHTML: _vm._s(subItems.taxoDesc) },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "list-wrap",
                              staticStyle: { display: "none" },
                            },
                            _vm._l(
                              subItems.childPost,
                              function (subItem, indexChildPostAnother) {
                                return _c(
                                  "article",
                                  {
                                    key: "key_" + indexChildPostAnother,
                                    staticClass: "item publication",
                                    class: {
                                      focus:
                                        _vm.form.page === 1 && indexChild === 0,
                                    },
                                    attrs: { "data-indexChild": indexChild },
                                  },
                                  [
                                    _c("div", { staticClass: "wrap-mobile" }, [
                                      _c("div", { staticClass: "bloc-titre" }, [
                                        _c("h3", {
                                          staticClass: "titre",
                                          domProps: {
                                            innerHTML: _vm._s(subItem.title),
                                          },
                                        }),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "infos-file" }, [
                                        _c("p", [
                                          _vm._v(_vm._s(subItem.infosFile)),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "echeance" }, [
                                        _c("p", {
                                          domProps: {
                                            innerHTML: _vm._s(subItem.echeance),
                                          },
                                        }),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "cta" }, [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "simple",
                                          attrs: {
                                            href: subItem.url,
                                            download: "",
                                          },
                                        },
                                        [
                                          _c("span", {
                                            staticClass: "icon-download",
                                          }),
                                        ]
                                      ),
                                    ]),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                        ]
                      )
                    : _vm._e()
                }),
              ],
              2
            )
          }),
          _vm._v(" "),
          _vm.result && _vm.result.length === 0
            ? _c("p", { staticClass: "no-results" }, [_vm._t("no-results")], 2)
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "clearfix" }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lds-ring" }, [
      _c("div"),
      _vm._v(" "),
      _c("div"),
      _vm._v(" "),
      _c("div"),
      _vm._v(" "),
      _c("div"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }